import api from './api.service';

export const offerLetterApi = {
  // Job Details
  getJobDetails: async (jobId) => {
    try {
      const response = await api.get(`/jobs/${jobId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting job details:', error);
      throw error.response?.data || error;
    }
  },

  // Template Management
  uploadTemplate: async (jobId, formData) => {
    try {
      const response = await api.post(`/offer-letter/jobs/${jobId}/offer-template`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading template:', error);
      throw error.response?.data || error;
    }
  },

  getTemplate: async (jobId) => {
    try {
      const response = await api.get(`/offer-letter/jobs/${jobId}/offer-template`);
      return response.data;
    } catch (error) {
      console.error('Error getting template:', error);
      throw error.response?.data || error;
    }
  },

  deleteTemplate: async (jobId) => {
    try {
      const response = await api.delete(`/offer-letter/jobs/${jobId}/offer-template`);
      return response.data;
    } catch (error) {
      console.error('Error deleting template:', error);
      throw error.response?.data || error;
    }
  },

  // Offer Generation
  getOfferFormData: async (resumeId) => {
    try {
      const response = await api.get(`/offer-letter/resumes/${resumeId}/offer-form-data`);
      return response.data;
    } catch (error) {
      console.error('Error getting offer form data:', error);
      throw error.response?.data || error;
    }
  },

  generateOffer: async (resumeId, offerData) => {
    try {
      const response = await api.post(`/offer-letter/resumes/${resumeId}/generate-offer`, offerData);
      return response.data;
    } catch (error) {
      console.error('Error generating offer:', error);
      throw error.response?.data || error;
    }
  },

  getOfferPreview: async (resumeId) => {
    try {
      const response = await api.get(`/offer-letter/resumes/${resumeId}/offer-preview`);
      return response.data;
    } catch (error) {
      console.error('Error getting offer preview:', error);
      throw error.response?.data || error;
    }
  },

  // deadline: 'YYYY-MM-DD', or empty for the default (7 days from sending). HIR-HR5.
  sendOffer: async (resumeId, deadline) => {
    try {
      const response = await api.post(`/offer-letter/resumes/${resumeId}/send-offer`, deadline ? { deadline } : {});
      return response.data;
    } catch (error) {
      console.error('Error sending offer:', error);
      throw error.response?.data || error;
    }
  },

  retryHandover: async (resumeId) => {
    try {
      const response = await api.post(`/offer-letter/resumes/${resumeId}/handover`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // HR records the candidate's answer on their behalf: 'accepted' | 'declined'. HIR-HR5.
  updateOfferStatus: async (resumeId, status, note) => {
    try {
      const apiResponse = await api.put(`/offer-letter/resumes/${resumeId}/offer-status`, {
        status,
        note
      });
      return apiResponse.data;
    } catch (error) {
      console.error('Error updating offer status:', error);
      throw error.response?.data || error;
    }
  },

  // HIR-HR5 — move the reply-by date of an offer still awaiting an answer.
  updateOfferDeadline: async (resumeId, deadline) => {
    try {
      const response = await api.put(`/offer-letter/resumes/${resumeId}/offer-deadline`, { deadline });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // HIR-HR5 — offers declined or lapsed, each with the next-ranked candidates.
  getFollowUps: async () => {
    try {
      const response = await api.get('/offer-letter/follow-ups');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  closeFollowUp: async (resumeId, note) => {
    try {
      const response = await api.post(`/offer-letter/resumes/${resumeId}/follow-up/done`, { note });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};
